import gql from "graphql-tag";

const AuthenticationQueries = {
  GET_TOKEN: gql`
    {
      token @client
    }
  `,
  IS_LOGIN: gql`
    {
      isLogin @client
    }
  `
};

export default AuthenticationQueries;
